import { useCallback } from 'react';

import DashboardOutlined from '@mui/icons-material/DashboardOutlined';
import ListAltOutlined from '@mui/icons-material/ListAltOutlined';

import { SPOT_CATALOG_PATH } from '@/constants/constants';
import { DataHubEmptyState } from '@/features/DataHub/components/DataHubEmptyState';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { closeDrawer } from '@/slices/drawerSlice';

export const PastExportsEmptyState = () => {
  const dispatch = useAppDispatch();

  const handleClick = useCallback(() => {
    dispatch(closeDrawer());
  }, [dispatch]);

  return (
    <DataHubEmptyState
      actions={[
        {
          label: 'Homepage',
          to: '/markets',
          icon: <DashboardOutlined />,
          replace: true,
          variant: 'contained',
          onClick: handleClick
        },
        {
          label: 'Catalog',
          to: `/catalog/${SPOT_CATALOG_PATH}`,
          icon: <ListAltOutlined />,
          replace: true,
          variant: 'contained',
          onClick: handleClick
        }
      ]}
      description={
        <>
          Your export history will appear here.
          <br /> Get started with one of the options below:
        </>
      }
      title='No past exports'
    />
  );
};
